import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import TopNav from "./components/TopNav";
import ArtistPage from "./pages/ArtistPage";
import PlayerBar from "./components/PlayerBar";
import VideoPlayerModal from "./components/VideoPlayerModal";
import CollectionSheet from "./components/CollectionSheet";
import EditPanel from "./components/EditPanel";
import AuthModal from "./components/AuthModal";
import AccountModal from "./components/AccountModal";
import ShareModal from "./components/ShareModal";
import WelcomeModal from "./components/WelcomeModal";
import SupportWidget from "./components/SupportWidget";
import TicketQRModal from "./components/TicketQRModal";
import PaymentModal from "./components/PaymentModal";
import PayBanner from "./components/PayBanner";
import RegistrationBanner from "./components/RegistrationBanner";
import PortalBackground from "./components/PortalBackground";
import { Toaster } from "./components/ui/toaster";

function Shell() {
  return (
    <>
      <div className="ambient-bg" />
      <PortalBackground />
      <div className="app-shell relative z-10">
        <TopNav />
        <RegistrationBanner />
        <ArtistPage />
        <PlayerBar />
        <VideoPlayerModal />
        <CollectionSheet />
        <EditPanel />
        <AuthModal />
        <AccountModal />
        <ShareModal />
        <WelcomeModal />
        <TicketQRModal />
        <PaymentModal />
      </div>
      <SupportWidget />
      <PayBanner />
      <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Shell />} />
          </Routes>
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
